import React from 'react'

export default function 
() {
  return (
    <div className='container' id="footer_container">
       <p id="organizator_name"><b>SHELLHACKS 2023</b></p>
        <p id='memory_name'>IN THE MEMORY OF GRAVIL WOODLY</p>

    </div>
  )
}
